const setClasses = (classes = '') => {
    return Array.isArray(classes) ? classes.join(' ') : classes
}

export default setClasses
